import React, { useState } from "react";
import "./packageslist.css";

// components imports
import PackagesTable from "../../../../../../../Components/BoltTable/BoltTable";
import Tooltip from "../../../../../../../Components/Tooltip/Tooltip";
import AddPackage from "../AddPackage/AddPackage";
import UpdatePackage from "../UpdatePackage/UpdatePackage";
import Confirm from "../../../../../../../Components/Popups/Confirm";

// apis imports
import {
  fetchAllPackages,
  deletePackage,
} from "../../../../../../../services/ShipperServices/Packages/packages.services";

// library imports
import { FaRegEdit } from "react-icons/fa";
import { MdAdd, MdOutlineCancel } from "react-icons/md";
import noImage from "../../../../../../../assets/images/noImage.png";
import BoltButton from "../../../../../../../Components/UI/Buttons/BoltButton";
import { useTranslation } from "react-i18next";

const Packages = ({ snack, setSnack }) => {
  const { t } = useTranslation("products");
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [addPackageModal, setAddPackageModal] = useState(false);
  const [deletePackageModal, setDeletePackageModal] = useState(false);
  const [updatePackageModal2, setUpdatePackageModal2] = useState(false);

  const [packages, setPackages] = useState([]);

  const columns = [
    {
      id: 0,
      label: "#",
      render: (row) => <>{row?.id ?? "-"}</>,
      width: "200px",
    },
    {
      id: 1,
      label: "image",
      field_name: "Image",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          <img
            src={row.file ?? noImage}
            onError={(e) => {
              e.target.src = noImage;
            }}
          />
        </>
      ),
      width: "200px",
    },
    {
      id: 2,
      label: t("packages.columns.packageName"),
      field_name: "package_name",
      render: (row, rowIndex, handleFieldChange) => <>{row.name ?? "-"}</>,
      width: "200px",
    },
    {
      id: 3,
      label: t("packages.columns.description"),
      field_name: "description",
      render: (row, rowIndex, handleFieldChange) => (
        <>{row.description ?? "-"}</>
      ),
      width: "200px",
    },
    {
      id: 4,
      label: t("packages.columns.length"),
      field_name: "length",
      render: (row, rowIndex, handleFieldChange) => <>{row.length ?? "-"}</>,
      width: "200px",
    },
    {
      id: 5,
      label: t("packages.columns.widthLower"),
      field_name: "Width",
      render: (row, rowIndex, handleFieldChange) => <>{row.width ?? "-"}</>,
      width: "200px",
    },
    {
      id: 6,
      label: t("packages.columns.height"),
      field_name: "height",
      render: (row, rowIndex, handleFieldChange) => <>{row.height ?? "-"}</>,
      width: "200px",
    },
    {
      id: 7,
      label: t("packages.columns.weight"),
      field_name: "weight",
      render: (row, rowIndex, handleFieldChange) => <>{row.weight ?? "-"}</>,
      width: "200px",
    },
    {
      id: 8,
      label: t("packages.columns.unit"),
      field_name: "unit",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          {row.unit
            ? t(`packages.units.${row.unit}`, { defaultValue: row.unit })
            : "-"}
        </>
      ),
      width: "200px",
    },
    {
      id: 9,
      label: t("packages.columns.action"),
      field_name: "action",
      render: (row, rowIndex, handleFieldChange) => (
        <>
          <div className="table_action__wrap">
            <Tooltip title={t("packages.editPackage")}>
              <div
                className="table_action__btn"
                onClick={() => setUpdatePackageModal2(row)}
              >
                <FaRegEdit size={10} />
                {t("common:actions.edit")}
              </div>
            </Tooltip>
            <Tooltip title={t("packages.deletePackage")}>
              <div
                className="table_action__btn"
                onClick={() => setDeletePackageModal(row.id)}
              >
                <MdOutlineCancel size={10} />
                {t("common:actions.delete")}
              </div>
            </Tooltip>
          </div>
        </>
      ),
      width: "200px",
    },
  ];

  const getAllPackages = async (page, perPage, filter) => {
    const response = await fetchAllPackages(page, perPage, filter);

    if (!response.error) {
      setPackages(response?.data?.result);
    } else {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        };
      });
    }
  };

  const deleteSinglePackage = async () => {
    setDeleteLoader(true);
    let id = deletePackageModal;
    const deleted = await deletePackage(deletePackageModal);
    if (deleted.error) {
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("packages.deleteFailed"),
          severity: "error",
        };
      });
      setDeleteLoader(false);
    } else {
      setPackages((prevPackages) => {
        return {
          ...prevPackages,
          data: prevPackages?.data?.filter((pkg) => pkg.id !== id),
        };
      });
      setSnack((snack) => {
        return {
          ...snack,
          open: true,
          text: t("packages.deleted"),
          severity: "success",
        };
      });
      setDeleteLoader(false);
      setDeletePackageModal(false);
    }
  };

  return (
    <div>
      <AddPackage
        open={addPackageModal}
        setOpen={setAddPackageModal}
        setSnack={setSnack}
        setRefresh={setRefresh}
      />
      <UpdatePackage
        open={updatePackageModal2}
        setOpen={setUpdatePackageModal2}
        previousData={updatePackageModal2}
        setSnack={setSnack}
        setPackages={setPackages}
      />
      <Confirm
        open={deletePackageModal}
        setOpen={setDeletePackageModal}
        handleConfirm={deleteSinglePackage}
        text={t("packages.deleteConfirm")}
        loader={deleteLoader}
      />

      <div>
        <PackagesTable
          tableTitle={t("packages.tableTitle")}
          tableId="PackagesListTableforShipper"
          message={t("packages.empty")}
          searchPlaceHolder={t("packages.search")}
          columns={columns}
          data={packages}
          getAllData={getAllPackages}
          refresh={refresh}
          headerButtons={
            <div className="flex gap-1 flex-wrap">
              <BoltButton
                icon={MdAdd}
                label={t("packages.add")}
                onClick={() => setAddPackageModal(true)}
                variant="primary"
                size="sm"
              />
            </div>
          }
        />
      </div>
    </div>
  );
};

export default Packages;
